import { CREATE_SEMANTIC_MODEL_CLASS_PROFILE, CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE, MODIFY_SEMANTIC_MODEL_CLASS_PROFILE, MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE } from "./operations.js";
class DefaultSemanticModelProfileOperationFactory {
    createClassProfile(entity) {
        return {
            type: CREATE_SEMANTIC_MODEL_CLASS_PROFILE,
            entity,
        };
    }
    modifyClassProfile(identifier, entity) {
        return {
            type: MODIFY_SEMANTIC_MODEL_CLASS_PROFILE,
            entity,
            identifier,
        };
    }
    createRelationshipProfile(entity) {
        return {
            type: CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE,
            entity,
        };
    }
    modifyRelationshipProfile(identifier, entity) {
        return {
            type: MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE,
            entity,
            identifier,
        };
    }
}
export function createDefaultSemanticModelProfileOperationFactory() {
    return new DefaultSemanticModelProfileOperationFactory();
}
//# sourceMappingURL=operations-factory.js.map